// libs
import React, { Suspense, memo } from 'react';
import { Switch, Route } from 'react-router-dom';

// global components
import NFLoader from 'shared/ui-components/NFLoader';

// constants
import {
  BASE_CART_URL,
  COUPONS_URL,
  ADDRESS_URL,
  ADDRESS_ADD_URL,
  ADDRESS_LIST_URL,
  ADDRESS_EDIT_URL,
  ADDRESS_GUEST_EDIT_URL,
  FREE_SAMPLE_URL,
} from 'shared/constants/uri';

// components
import Cart from 'shared/layouts/Cart';
import CustomerProvider from 'shared/components/CustomerProvider';
import CartProvider from 'shared/components/CartProvider';

const Coupons = React.lazy(
  () => import(/* webpackChunkName: "coupons" */ 'shared/layouts/Coupons')
);

const Address = React.lazy(
  () => import(/* webpackChunkName: "address-new" */ 'shared/layouts/Address')
);
const NewAddress = React.lazy(
  () => import(/* webpackChunkName: "address-new" */ 'shared/layouts/NewAddress')
);
const AddressList = React.lazy(
  () => import(/* webpackChunkName: "address-list" */ 'shared/layouts/AddressList')
);
const EditAddress = React.lazy(
  () => import(/* webpackChunkName: "address-edit" */ 'shared/layouts/EditAddress')
);
const GuestEditAddress = React.lazy(
  () => import(/* webpackChunkName: "address-guest-edit" */ 'shared/layouts/GuestEditAddress')
);

const FreeSamplePage = React.lazy(
  () => import(/* webpackChunkName: "free-sample" */ 'shared/layouts/FreeSample')
);

function Routes() {
  return (
    <CustomerProvider>
      <CartProvider>
        <Suspense fallback={<NFLoader />}>
          <Switch>
            <Route path={BASE_CART_URL} exact component={Cart} />
            <Route path={COUPONS_URL} exact component={Coupons} />
            <Route path={ADDRESS_URL} exact component={Address} />
            <Route path={ADDRESS_ADD_URL} exact component={NewAddress} />
            <Route path={ADDRESS_LIST_URL} exact component={AddressList} />
            <Route path={ADDRESS_EDIT_URL} exact component={EditAddress} />
            <Route path={ADDRESS_GUEST_EDIT_URL} exact component={GuestEditAddress} />
            <Route path={FREE_SAMPLE_URL} exact component={FreeSamplePage} />
          </Switch>
        </Suspense>
      </CartProvider>
    </CustomerProvider>
  );
}

export default memo(Routes);
